import DebitCardFundingScreen from 'features/moveMoney/screens/dcf/DebitCardFundingScreen';
import React from 'react';

export default function ProgressTrackerDebitCardFundingPage() {
  return <DebitCardFundingScreen source="progress-tracker-funding" />;
}
